import displayStream from '../../views/viewMulti/displayStream.vue';
export default [
  {
    path: '/app/user/map',
    name: 'mapMarkerUser',
    components: {
      default: () => import('../../views/mapDevice/indexUser.vue')
    }
  },
  {
    path: '/multipleView',
    name: 'multipleViewUser',
    components: {
      default: () => import('../../views/viewMulti/indexUser.vue')
    }
  },
  {
    path: '/watch',
    name: 'Watch',
    component: () => import('../../views/viewMulti/viewOne.vue'),
    children: [
      {
        name: 'Live',
        path: 'live',
        component: displayStream
      },
      {
        name: 'playBack',
        path: 'playBack',
        component: () => import('../../views/viewMulti/playBack.vue')
      }
    ]
  },
  {
    path: '/listPlayBack',
    name: 'managePlayBack',
    component: () => import('../../views/managePlayBack/listPlayBack.vue')
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/mapUser.js